import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import InnerPageHeading from './InnerPageHeading';
import CountryForm from './CountryForm';

function ServiceListSingle(){
	
	const { id } = useParams();  // use 'id' instead of 'country'
	const [content, setContent] = useState(<div>Page Coming Soon...</div>);
	const [backgroundImage, setBackgroundImage] = useState("/images/page_header.jpg");

	useEffect(() => {
    if (!id) {
      setContent(<div>Page Coming Soon...</div>);
      setBackgroundImage("/images/page_header.jpg");
      return;
    }

    const fetchData = async () => {
      try {
        let imageUrl = "/images/page_header.jpg"; // Default image URL
        let contentComponent = <div>Page Coming Soon...</div>;

        switch (id.toLowerCase()) {
          case 'export-import-logistics':
            contentComponent = <ExportContent />;
            imageUrl = "/global/Australia-hero-img.jpeg";
            break;
          case 'local-transportation':
            contentComponent = <LocalContent />;
            imageUrl = "/global/china-hero-img.jpeg";
            break;
          case 'air-freight-import-export':
            contentComponent = <AirContent />;
            imageUrl = "/global/india-hero-img.jpeg";
            break;
          case 'ocean-freight-import-export':
            contentComponent = <OceanContent />;
            imageUrl = "/service/ocean_freight_import_export.jpg";
            break;
          case 'freight-forwarding':
            contentComponent = <FreightContent />;
            imageUrl = "/global/Malaysia-hero-img.jpeg";
            break;
          case 'customs-clearance':
            contentComponent = <CustomsContent />;
            imageUrl = "/global/WeFreight-Mexico.jpg";
            break;
          case 'warehousing-distribution':
            contentComponent = <WarehousingContent />;
            imageUrl = "/global/Saudi-Arabia-hero-img.jpeg";
            break;
          
          default:
            contentComponent = <div>Page Coming Soon...</div>;
        }

        setContent(contentComponent);
        setBackgroundImage(imageUrl);
      } catch (error) {
        console.error("Error fetching content:", error);
        setContent(<div>Error loading content</div>);
      }
    };

    fetchData();
  }, [id]);

  // Define country-specific content components
  const ExportContent = () => (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <h1>From Here to Anywhere: Simplifying Logistics</h1>
          <p className="intro-lead">Export-Import Logistics</p>
          <p className="intro-txt">
            Efficient, accurate, and compliant logistics procedures are particularly significant for those businesses associated with global trade. APN Shiptrack International Exim LLP offers a complete package of logistics solutions that work to export-import requirements with a spectrum to connect and help customers trade globally, reduce costs, and deliver goods on time across borders.
            </p>
			<p className="intro-lead"><b>Our Export-Import Logistics Services:</b></p>
			<p className="intro-lead">Freight Forwarding</p>
			<p className="intro-txt">
           We provide extensive air, marine, and land freight forwarding services. Whether you're shipping large volumes or time-sensitive cargo, our global network ensures that your goods are moved swiftly and securely to their destination.
            </p>
			
			<p className="intro-lead">Customs Clearance</p>
			<p className="intro-txt">
           Navigating tariff regulations is complicated and time-consuming. The expert team of customs brokerage professionals will help your shipment comply with every single requirement of the law and hence reduce delays and eliminate any kind of costly penalties.
            </p>
			
			<p className="intro-lead">Documentation Support</p>
			<p className="intro-txt">
           We assist with all necessary paperwork and documentation for export and import processes, ensuring smooth and error-free transactions. From bills of lading to letters of credit, we manage everything to ensure compliance with international trade laws.
            </p>
			
			<p className="intro-lead">Warehousing & Distribution</p>
			<p className="intro-txt">
          Our strategically located warehouses are equipped with advanced technology for inventory management and distribution. Whether you need short-term storage or long-term warehousing, we provide flexible solutions that keep your supply chain responsive and efficient.
            </p>
			
			<p className="intro-lead">Multi-Modal Transportation</p>
			<p className="intro-txt">
          Our integrated multi-modal transportation solutions allow for seamless movement of goods across various transportation modes, ensuring flexibility and cost-efficiency. Whether you need air, sea, or land transport, we provide customized options that suit your needs.
            </p>
			
		  <p className="intro-lead"><b>Why Choose APN Shiptrack for Export-Import Logistics?</b></p>
		  
		  <p className="intro-lead">Customs Expertise</p>
			<p className="intro-txt">
          We handle the complexities of customs clearance, ensuring your goods move smoothly across borders without unnecessary delays.
            </p>
			
			<p className="intro-lead">Real-Time Tracking</p>
			<p className="intro-txt">
           With our advanced tracking systems, you’ll have full visibility over your shipments, with updates provided in real-time.
            </p>
			
			<p className="intro-lead">Personalized Solutions</p>
			<p className="intro-txt">
          We understand that every business has unique needs, and we tailor our services to provide the most efficient, cost-effective solutions for your specific requirements.
            </p>
			
			
			<p className="intro-lead"><b>Partner with APN Shiptrack for Global Success</b></p>
			
		   <p className="intro-txt"> At APN Shiptrack, we are committed to helping businesses thrive in the global marketplace. With our export-import logistics services, you can focus on growing your business while we take care of the complexities of global trade and logistics.</p>
		   
		   <p className="intro-txt"></p>
        </div>
		
        <div className="col-12"><CountryForm /></div>
      </div>
    </div>
  );
  
  
  // Define country-specific content components
  const LocalContent = () => (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <h1>Local Transportation Services</h1>
          <p className="intro-lead"></p>
          <p className="intro-txt">
            At APN Shiptrack International Exim LLP, we provide fast, reliable, and cost-effective local transportation solutions. Whether you need to move goods within the city or across the region, our fleet and experienced drivers ensure timely deliveries with the utmost care. 
            </p>
			 <p className="intro-lead">Key Services:</p>
			<p>
			Same-Day & Next-Day Delivery: Prompt service for urgent shipments.

			</p>
			<p>
			Fleet Options: Tailored transport solutions with trucks, vans, and specialized vehicles.
			</p>
			<p>
			Last-Mile Delivery: Efficient final-leg service to ensure goods reach their destination on time.
			</p>
			<p>
			Real-Time Tracking: Stay updated with live tracking and delivery status.
			</p>
			<p>
			Trust us to deliver your goods safely and on schedule!
          </p>
		   <p className="intro-txt"> </p>
        </div>
        <div className="col-12"><CountryForm /></div>
      </div>
    </div>
  );
  
   // Define country-specific content components
  const AirContent = () => (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <h1>Air Freight Solutions for Swift, Global Deliveries.</h1>
          <p className="intro-lead">Air Freight Import-Export Services</p>
          <p className="intro-txt">
            Air freight is the fastest and most reliable way to move goods across international borders. At APN Shiptrack International Exim LLP, we specialize in providing efficient and cost-effective air freight solutions for both imports and exports. Our global network, industry expertise, and commitment to customer satisfaction ensure that your shipments are handled with care, delivered on time, and fully compliant with international regulations.
            </p>
			<p className="intro-lead"><b>Our Air Freight Services Include:</b></p>
			<p className="intro-lead">Door-to-Door Air Freight</p>
			<p className="intro-txt">
          We offer seamless door-to-door air freight services, managing every step of the logistics process from pick-up at your location to delivery at the final destination. This service takes the hassle out of coordinating multiple providers and ensures a smooth, end-to-end shipping experience.
            </p>
			
			<p className="intro-lead">Express Air Freight</p>
			<p className="intro-txt">
           For time-sensitive shipments, our express air freight service guarantees fast delivery. Whether it's an urgent shipment of spare parts, or critical inventory, we provide priority handling to ensure your goods reach their destination quickly and safely.
            </p>
			
			<p className="intro-lead">Consolidated Air Freight</p>
			<p className="intro-txt">
           If you’re looking to save on shipping costs without compromising on speed, our consolidated air freight service is the perfect solution. We group your cargo with other shipments heading to the same destination, optimizing space and reducing costs.
            </p>
			
			<p className="intro-lead">Charter Services</p>
			<p className="intro-txt">
         For large, oversized, or high-value shipments, our air charter services provide the flexibility and security your business needs. We arrange charter flights to transport goods directly to your destination, ensuring complete control over the shipping process.
            </p>
			
			<p className="intro-lead">Dangerous Goods Handling</p>
			<p className="intro-txt">
          Transporting hazardous or dangerous goods via air requires specialized knowledge and handling. At APN Shiptrack, we are fully compliant with International Air Transport Association (IATA) regulations, and our team is trained to manage dangerous goods safely and securely.
            </p>
			
		  <p className="intro-lead"><b>APN Shiptrack for Air Freight Import-Export?</b></p>
		  
		  <p className="intro-lead">Global Reach with Local Expertise</p>
		  <p className="intro-txt">
          We offer global coverage through our network of trusted partners and agents, ensuring efficient import and export of goods with local expertise and international reach.
          </p>
			
			<p className="intro-lead">Advanced Tracking and Visibility</p>
			<p className="intro-txt">
          Real-time tracking is provided for all air freight shipments, ensuring constant cargo location and control over the supply chain.
            </p>
			
			<p className="intro-lead">Timely Deliveries</p>
			<p className="intro-txt">
          APN Shiptrack prioritizes speed in air freight, partnering with major airlines and focusing on efficient routing to reduce transit times and ensure reliable delivery.
            </p>
			
			<p className="intro-lead">End-to-End Logistics Management</p>
			<p className="intro-txt">
          APN Shiptrack provides comprehensive air freight services, including forwarding, customs clearance, warehousing, and final delivery, ensuring professionalism and care in every aspect of your shipment.
            </p>
			
			<p className="intro-lead">Competitive Pricing</p>
			<p className="intro-txt">
			We offer competitive air freight pricing without compromising on quality, allowing businesses to manage costs effectively while enjoying fast, reliable solutions.
            </p>
			
			<p className="intro-lead"><b>Industries We Serve:</b></p>
			<p className="intro-txt">
          Among the many industries served by APN Shiptrack's air freight services are:
            </p>
			
			<p className="intro-lead">E-Commerce</p>
			<p className="intro-txt">
           Express air freight services to meet the demands of global e-commerce businesses.
            </p>
			
			<p className="intro-lead">Automotive</p>
		    <p className="intro-txt">
          Air freight solutions for the rapid movement of parts, components, and finished vehicles.
            </p>
			
			<p className="intro-lead">Retail</p>
			<p className="intro-txt">
           Efficient import and export services for fashion, electronics, and consumer goods.
            </p>
			
			<p className="intro-lead">Manufacturing</p>
			<p className="intro-txt">
           Reliable transport of raw materials and finished products to and from manufacturing hubs.
            </p>
			
			
			<p className="intro-lead"><b>Get Started with APN Shiptrack’s Air Freight Solutions</b></p>
			
		   <p className="intro-txt"> When it comes to air freight import-export, speed, reliability, and flexibility are key. At APN Shiptrack International Exim LLP, we are dedicated to providing customized air freight solutions that meet your business needs and ensure your shipments reach their destination safely and on time.</p>
		   
		   <p className="intro-txt"></p>
        </div>
		
        <div className="col-12"><CountryForm /></div>
      </div>
    </div>
  );
  
   // Define country-specific content components
  const OceanContent = () => (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <h1>Connecting Continents with Efficient Ocean Freight Services.</h1>
          <p className="intro-lead">Ocean Freight Import & Export Services</p>
          <p className="intro-txt">
            At APN Shiptrack International Exim LLP, we understand the critical role that ocean freight plays in global trade. With our comprehensive ocean freight import and export solutions, we ensure that your goods are transported safely, efficiently, and economically across the world's oceans. Whether you're shipping bulk commodities, industrial goods, or consumer products, our ocean freight services are designed to meet the unique needs of your business.
            </p>
			<p className="intro-lead"><b>Our Ocean Freight Services Include:</b></p>
			<p className="intro-lead">Full Container Load (FCL)</p>
			<p className="intro-txt">
           For businesses with larger shipments, Full Container Load (FCL) services offer dedicated container space for your cargo. This service is ideal for companies that need to ship goods in bulk, ensuring secure handling and efficient delivery at a competitive price.
            </p>
			
			<p className="intro-lead">Less Than Container Load (LCL)</p>
			<p className="intro-txt">
           If your cargo doesn’t fill an entire container, our Less Than Container Load (LCL) service allows you to share container space with other shipments. This cost-effective solution is perfect for smaller shipments, reducing costs while maintaining timely service.
            </p>
			
			<p className="intro-lead">Customs Clearance & Compliance</p>
			<p className="intro-txt">
          Navigating international regulations and customs procedures can be complex. Our experienced team ensures that your ocean freight shipments comply with all necessary customs regulations, handling the documentation, duties, and taxes on your behalf to ensure smooth and fast clearance.
            </p>
			
			<p className="intro-lead">Port-to-Port & Door-to-Door Services</p>
			<p className="intro-txt">
         APN Shiptrack offers both port-to-port and door-to-door ocean freight services, depending on your needs. Our port-to-port services are designed for companies that have an established logistics network at both ends of the shipment. For businesses seeking full-service logistics, our door-to-door option provides an all-in-one solution, including pickup, delivery, and everything in between.
            </p>
			
		  <p className="intro-lead"><b>We Ensure Smooth Ocean Freight Operations?</b></p>
		  
		  <p className="intro-lead">Experienced Team</p>
			<p className="intro-txt">
          Our logistics experts have years of experience in managing ocean freight and handling international shipping logistics.
            </p>
			
			<p className="intro-lead">Advanced Technology</p>
			<p className="intro-txt">
           From tracking systems to route optimization, we use the latest technology to manage your shipments efficiently and effectively.
            </p>
			
			<p className="intro-lead">Comprehensive Documentation</p>
			<p className="intro-txt">
          We handle all paperwork, including shipping documents, customs forms, and invoices, ensuring a smooth and compliant process.
            </p>
			
			<p className="intro-lead">Global Shipping Network</p>
			<p className="intro-txt">
         Our vast network of partners and agents around the world ensures that we can offer services to virtually any port or destination.
            </p>
			
			
			<p className="intro-lead"><b>Get Started with APN Shiptrack</b></p>
			
		   <p className="intro-txt"> Shipping goods by ocean doesn’t have to be complicated. With APN Shiptrack, you get reliable, cost-effective, and efficient ocean freight services that support your business every step of the way. Our dedicated team works with you to develop a shipping plan that aligns with your business needs, ensuring that your goods are delivered on time, in perfect condition, and within budget.
</p>
		   
		   <p className="intro-txt">Contact us today to learn more about our ocean freight solutions and how we can help streamline your import and export logistics!</p>
		     <p className="intro-txt"></p>
		   
        </div>
		
        <div className="col-12"><CountryForm /></div>
      </div>
    </div>
  );
  
  // Define country-specific content components
  const FreightContent = () => (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <h1>Reliable Freight Forwarding for a Smooth Journey</h1>
          <p className="intro-lead">Freight Forwarding Services</p>
          <p className="intro-txt">
            At APN Shiptrack International Exim LLP, we offer comprehensive freight forwarding services designed to streamline your global shipping operations. Our expertise in handling complex logistics challenges, along with our established network of trusted carriers and agents, ensures that your shipments are delivered efficiently, securely, and on time. Whether you're importing or exporting goods, our freight forwarding services are customized to meet the unique needs of your business, ensuring smooth and seamless transportation across land, sea, and air.
            </p>
			<p className="intro-lead"><b>What is Freight Forwarding?</b></p>
			<p className="intro-txt">
          Freight forwarding is the process of coordinating the shipment of goods from one point to another using various carriers and modes of transport. A freight forwarder acts as an intermediary between the shipper and transportation services, managing the logistics to ensure the efficient movement of goods. From booking cargo space and handling documentation to coordinating transportation and providing tracking, freight forwarding ensures that your goods reach their destination without hassle.
            </p>
			
			<p className="intro-lead"><b>Our Freight Forwarding Services Include:</b></p>
			<p className="intro-lead">Air Freight Forwarding</p>
			<p className="intro-txt">
           Our air freight forwarding service offers fast, reliable deliveries worldwide, offering express services for urgent shipments and cost-effective solutions for less time-sensitive cargo.
            </p>
			
			<p className="intro-lead">Ocean Freight Forwarding</p>
			<p className="intro-txt">
           APN Shiptrack manages ocean freight for larger, heavier shipments, ensuring safe, timely, and budget-friendly delivery through booking, routing, and documentation.
            </p>
			
			<p className="intro-lead">Customs Brokerage & Clearance</p>
			<p className="intro-txt">
          APN Shiptrack manages shipments, ensuring regulatory compliance, efficient customs clearance, and timely delivery by handling paperwork, duties, and taxes, reducing delays and ensuring timely delivery.
            </p>
			
			<p className="intro-lead">Warehousing & Distribution</p>
			<p className="intro-txt">
          We provide secure warehousing solutions for businesses, ensuring efficient and safe storage of goods with real-time inventory management, handling every step of the logistics chain.
            </p>
			
			
			
		  <p className="intro-lead"><b>Our Freight Forwarding Process</b></p>
		  
		  <p className="intro-lead"> Initial Consultation</p>
			<p className="intro-txt">
          Our team understands your unique shipping needs, including goods type, origin/destination, and special conditions, and provides recommendations and tailored solutions.
            </p>
			
			<p className="intro-lead">Planning and Coordination</p>
			<p className="intro-txt">
          We book cargo space with trusted carriers, secure efficient routes, and coordinate all details, from documentation to customs procedures, after understanding your needs.
            </p>
			
			<p className="intro-lead">Shipment Monitoring and Tracking</p>
			<p className="intro-txt">
         During transit, our advanced tracking system allows you to stay updated on the status of your goods. We provide you with detailed information, so you know exactly when and where your cargo will arrive.
            </p>
			
			
			<p className="intro-lead">Delivery and Final Handling</p>
			<p className="intro-txt">
         Our team manages customs clearance and final delivery of goods to your destination, ensuring safe and accurate delivery to the correct address.
            </p>
			
			
			<p className="intro-lead"><b>How APN Shiptrack Makes Freight Forwarding Simple</b></p>
			
		    <p className="intro-lead">Expertise</p>
		    <p className="intro-txt">Our experienced team guides you through every step of the freight forwarding process, ensuring your shipments are handled efficiently and effectively.</p>
		   
		   <p className="intro-lead">Flexibility</p>
		   <p className="intro-txt">Whether you need air, ocean, or land transport, we offer flexible solutions to suit your needs.</p>
		   
		   
		   <p className="intro-lead">Transparency</p>
		   <p className="intro-txt">Real-time tracking and updates keep you informed at every stage of your shipment’s journey.</p>
		   
		   <p className="intro-lead">Compliance</p>
		   <p className="intro-txt">We ensure that all documentation, duties, and customs procedures are handled to meet international standards.</p>
		   
		   <p className="intro-txt"></p>
        </div>
		
        <div className="col-12"><CountryForm /></div>
      </div>
    </div>
  );
  /////////////////////////////////////////////
  
  // Define country-specific content components
  const CustomsContent = () => (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <h1>Customs Clearance Services</h1>
         <p className="intro-lead"></p>
          <p className="intro-txt">
            At APN Shiptrack International Exim LLP, we specialize in providing seamless and efficient customs clearance services for businesses engaged in international trade. Navigating the complexities of customs regulations can be daunting, but with our experienced team of customs experts, we ensure that your shipments move smoothly through customs, avoiding delays and compliance issues. We take care of all the necessary documentation, tariffs, and taxes, allowing you to focus on your core business operations while we handle the red tape.
            </p>			 
			<p className="intro-lead"><b>Customs Clearance</b></p>
			<p className="intro-txt">Customs clearance is the process of ensuring that goods entering or leaving a country comply with the regulations and laws of that country’s customs authorities. It involves the submission of various documents, including invoices, bills of lading, and certificates, as well as payment of duties and taxes. Customs clearance is a critical step in international trade as it ensures that shipments are authorized to enter or exit a country legally and without delay. </p>
			
			<p className="intro-lead"><b>Why APN Shiptrack for Customs Clearance?</b></p>
		  
			<p className="intro-lead">Expert Knowledge of Customs Regulations</p>
			<p className="intro-txt">
          APN Shiptrack ensures your shipments comply with local and international customs regulations, avoiding delays, fines, and legal issues.
            </p>
			
			<p className="intro-lead">Timely and Efficient Processing</p>
			<p className="intro-txt">
          APN Shiptrack prioritizes efficient customs clearance, ensuring accurate documentation and timely submission to minimize delays and disruptions to your supply chain.
            </p>
			
			<p className="intro-lead">Comprehensive Documentation Services</p>
			<p className="intro-txt">
          APN Shiptrack handles all customs documentation, ensuring accuracy, completeness, and timely submission to reduce errors and ensure smooth clearance.
            </p>
			
			
			<p className="intro-lead">Duty and Tax Calculation</p>
			<p className="intro-txt">
         APN Shiptrack calculates accurate duties and taxes, ensuring timely payments and smooth customs clearance without surprises or delays.
            </p>
			
			<p className="intro-lead">Customs Bond Services</p>
			<p className="intro-txt">
         APN Shiptrack arranges customs bonds, ensuring compliance with duties and taxes, managing logistics for smooth clearance and peace of mind.
            </p>
			
			
			<p className="intro-lead"><b>Our Customs Clearance Services Include:</b></p>
			
		    <p className="intro-lead">Import Customs Clearance</p>
		    <p className="intro-txt">We manage import clearance, handling documents, duties, and taxes, ensuring efficient goods clearance and compliance with local customs regulations.</p>
		   
		   <p className="intro-lead">Export Customs Clearance</p>
		   <p className="intro-txt">Whether you need air, ocean, or land transport, we offer flexible solutions to suit your needsWe manage export clearance, ensuring regulatory compliance, handling export documents, and supporting adherence to international trade laws for seamless shipments..</p>
		   
		   
		   <p className="intro-lead">Transparency</p>
		   <p className="intro-txt">Real-time tracking and updates keep you informed at every stage of your shipment’s journey.</p>
		   
		   <p className="intro-lead">Compliance</p>
		   <p className="intro-txt">We ensure that all documentation, duties, and customs procedures are handled to meet international standards.</p>
		   
			
			<p className="intro-txt"> </p>
        </div>
        <div className="col-12"><CountryForm /></div>
      </div>
    </div>
  );
  
  // Define country-specific content components
  const WarehousingContent = () => (
    <div className="container">
      <div className="row">
       <div className="col-12">
          <h1>Warehousing & Distribution Services</h1>
          <p className="intro-txt">
            APN Shiptrack International Exim LLP offers secure, efficient warehousing and distribution solutions to support your supply chain. Our state-of-the-art facilities and optimized distribution networks ensure timely, accurate deliveries to your customers.
            </p>
			 <p className="intro-lead">Key Services:</p>
			<p>
			Storage Solutions: Safe, scalable warehousing for short or long-term needs.

			</p>
			<p>
			Inventory Management: Real-time tracking and stock control.
			</p>
			<p>
			Order Fulfillment: Fast and accurate picking, packing, and shipping.
			</p>
			<p>
			Strategic Distribution: Optimized delivery routes for faster customer reach.
			</p>
			<p>
			Rely on us for seamless warehousing and distribution that keeps your business running smoothly!
          </p>
		   <p className="intro-txt"> </p>
        </div>
        <div className="col-12"><CountryForm /></div>
      </div>
    </div>
  );

  // Define similar components for other countries

  const countryTitle = id ? id.charAt(0).toUpperCase() + id.slice(1) : "Unknown";

  return (
    <>
      <InnerPageHeading title={`Global Serives Estimate - ${countryTitle}`} backgroundImage={backgroundImage} />
      <section className="gfe-sec">
        <div className="container">
          <div className="content">
            {content}
          </div>
        </div>
      </section>
    </>
  );
}

export default ServiceListSingle;